import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import Divider from '@material-ui/core/Divider';
import { safeGet } from '../../../core/util/object';
import Actions, { ActionImplementations } from './components/Actions';
import Breadcrumb from './components/BreadCrumb/components/Breadcrumb';
import { getCDPCrumbs } from './components/BreadCrumb/util/breadcrumb';
import ClinicName from './components/ClinicName';
import ClinicPhoto from './components/ClinicPhoto';
import QuickDetails from './components/QuickDetails';
import Rating from './components/Rating';
import ReportInaccurateInfo from './components/ReportInaccurateInfo';
import Book from '../Book/Mobile';
import Accreditation from '../Book/components/Accreditation';
import ClaimClinic from './components/ClaimClinic';
import { ROOT_PADDING } from '../constants';
import SolvVerifiedBadge from '../../SolvPatternLibrary/SolvVerifiedBadge';
import { isBookable } from '../../../core/util/location';
import { colors } from '../../../constants/colors';

const HeaderCard = styled.div`
  text-align: center;
`;

const MobileClinicPhoto = styled(ClinicPhoto)`
  width: 35vw;
  height: 35vw;
  margin: 20px 0;
  max-width: 200px;
  max-height: 200px;
`;

const StyledRating = styled(Rating)`
  margin: 20px 0 12px;
`;

const StyledDivider = styled(Divider)`
  width: 60%;
  margin: 28px auto;
`;

const CenteredClaimClinic = styled(ClaimClinic)`
  justify-content: center;
  margin: 15px 0 0;
`;

const CenteredReport = styled(ReportInaccurateInfo)`
  justify-content: center;
  margin: 0 0 25px;
`;

const CenteredSolvVerifiedBadge = styled(SolvVerifiedBadge)`
  justify-content: center;
  margin: 0 10px 2px 0;
`;

const BreadcrumbContainer = styled.div`
  border-bottom: 1px solid ${colors.dorianGrey};
  margin: 0 -16px;
  padding: 10px 14px;
  background-color: ${colors.whiteGrey};
`;

export default class MobileCdpHeaderCard extends PureComponent {
  static propTypes = {
    location: PropTypes.object,
    handleOpenCarousel: PropTypes.func,
    showModal: PropTypes.func,
    sessionTrackingProperties: PropTypes.object,
  };

  render = () => {
    const { location, handleOpenCarousel, showModal, sessionTrackingProperties } = this.props;

    return (
      <Fragment>
        <BreadcrumbContainer>
          <Breadcrumb
            sessionTrackingProperties={sessionTrackingProperties}
            crumbs={getCDPCrumbs(location)}
          />
        </BreadcrumbContainer>
        <HeaderCard>
          <Actions
            implementation={ActionImplementations.MOBILE}
            showModal={showModal}
            location={location}
          />
          <MobileClinicPhoto
            handleOpenCarousel={() => handleOpenCarousel('clinicPhoto')}
            location={location}
          />
          {isBookable(location) && (
            <CenteredSolvVerifiedBadge fontSize={12} badgeSize={18} badgeCopy="Solv Verified" />
          )}
          <ClinicName
            primaryName={location.displayNamePrimary}
            secondaryName={location.displayNameSecondary}
            alternateName={location.alternateName}
          />
          <StyledRating location={location} showModal={showModal} />
          <Book containerPadding={ROOT_PADDING} location={location} showModal={showModal} />

          <QuickDetails location={location} />
          <Accreditation location={location} />

          <StyledDivider />

          <CenteredClaimClinic
            location={location}
            userAgent={safeGet(sessionTrackingProperties)('userAgent')}
          />
          <CenteredReport location={location} showModal={showModal} />
        </HeaderCard>
      </Fragment>
    );
  };
}
